// A24 legal-document versioning + consent — module-local data layer. REAL backend
// (/admin/legal-docs*). Publish one version per kind; app fetches + records consent.
import { api } from '@/lib/api'

export interface KindSummary {
  kind: string
  versions: number
  published_version: number
  published_title: string
  consents: number
}
export interface DocVersion {
  id: number
  version: number
  title: string
  published: boolean
  published_at: string | null
  length: number
  created_at: string
}
export interface VersionDetail {
  id: number
  kind: string
  version: number
  title: string
  content: string
  published: boolean
  published_at: string | null
}
export interface ConsentStats {
  kind: string
  published_version: number
  current_version_consents: number
  total_consents: number
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchKinds = (s?: AbortSignal) =>
  api.get<{ kinds: KindSummary[] }>('/admin/legal-docs', opt(s)).then((d) => d.kinds ?? [])
export const fetchVersions = (kind: string, s?: AbortSignal) =>
  api.get<{ versions: DocVersion[] }>('/admin/legal-docs/versions', { query: { kind }, ...(s ? { signal: s } : {}) }).then((d) => d.versions ?? [])
export const fetchVersion = (id: number, s?: AbortSignal) =>
  api.get<{ version: VersionDetail }>(`/admin/legal-docs/versions/${id}`, opt(s)).then((d) => d.version)
export const createVersion = (kind: string, title: string, content: string) =>
  api.post<{ id: number; version: number }>('/admin/legal-docs', { kind, title, content })
export const publishVersion = (id: number) =>
  api.post<{ ok: boolean; kind: string }>(`/admin/legal-docs/versions/${id}/publish`, {})
export const fetchConsentStats = (kind: string, s?: AbortSignal) =>
  api.get<ConsentStats>('/admin/legal-docs/consents', { query: { kind }, ...(s ? { signal: s } : {}) })

export const KINDS = [
  { key: 'tos', label: 'Условия (ToS)' },
  { key: 'privacy', label: 'Конфиденциальность' },
  { key: 'guidelines', label: 'Правила' },
  { key: 'cookie', label: 'Cookie' },
] as const

export const LD_STR = {
  title: 'Юридические документы',
  desc: 'Версии ToS / Конфиденциальности + согласия пользователей',
  published: 'Опубликовано',
  draft: 'Черновик',
  version: 'Версия',
  versions: 'Версии',
  consents: 'Согласия',
  newVersion: 'Новая версия',
  docTitle: 'Заголовок',
  content: 'Текст документа',
  create: 'Создать черновик',
  publish: 'Опубликовать',
  view: 'Просмотр',
  close: 'Закрыть',
  none: 'Нет опубликованной версии',
  noVersions: 'Нет версий — создайте первую',
  adoption: 'Приняли текущую версию',
  of: 'из',
  done: 'Готово',
  failed: 'Ошибка',
  refresh: 'Обновить',
  chars: 'симв.',
} as const
